module.exports = __webpack_public_path__ + "static/media/mastercard.675e7fdc.svg";